"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user_group.list': 'User Groups',
    'route.user_group.create': 'Add User Group',
};
